// Module
var code = "<div class=\"msso-screen msso-login-screen\"> <div class=\"msso-text msso-logging-in\">Logging in...</div> </div> ";
// Exports
module.exports = code;